import { useContext, useEffect, useState } from 'react';
import { useYoConfigSnapshots } from '@yakoffice/yakoffice-firebase';
import { useYoProjectsSnapshots } from '@yakoffice/yakoffice-firebase';
import { useYoToolsSnapshots } from '@yakoffice/yakoffice-firebase';
import { AuthUserContext } from '@yakoffice/yakoffice-firebase';
import { hostedOnYakOfficeAppUrl } from '@yakoffice/helpers';

export const useNavigationRail = () => {

    const authUser = useContext(AuthUserContext);
    const { yoConfig, error: yoConfigError } = useYoConfigSnapshots();
    const { yoProjects, error: yoProjectsError } = useYoProjectsSnapshots();
    const { yoTools, error: yoToolsError } = useYoToolsSnapshots();
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
            if (yoConfigError != null)
                setError(yoConfigError);

            if (yoProjectsError != null)
                setError(yoProjectsError);

            if (yoToolsError != null)
                setError(yoToolsError);

        }, [yoConfigError, yoProjectsError, yoToolsError]
    );


    const isDevSite = () => hostedOnYakOfficeAppUrl(window.location.hostname);

    return { authUser, yoConfig, yoProjects, yoTools, error, isDevSite };
};
